export const projectRouter = [
    {
        path: '/projects',
        name: 'projects',
        component: () => import('../views/projects/Projects.vue')
    },
    {
        path: '/project/pages',
        name: 'pages',
        component: () => import('../views/projects/Pages.vue')
    },
    {
        path: '/project/page-modeler',
        name: 'pagemodeler',
        component: () => import('../views/projects/PageModeler.vue'),
        meta: {
            requiresAuth: true
        }
    }
];
